<template>
  <b-row class="margin-0">
    <b-col cols="12" class="padding-0 height--max-content">
      <ListWrapper
        ref="listWrapperReference"
        :url="listUrl"
        :title="$lang.activities"
        titleClass="padding-x-16"
        :isUseInSidebar="true"
        :hasAddButton="!isReadonly"
        :addButtonText="$lang.newActivity"
        menuBarClass="padding-x-16"
        searchTxtClass="width-percent-100"
        wrapperClass="background-surface border-radius-8 border--solid border--complementary-50 padding-y-16"
        wrapperListContentClass="height--100vh--369"
        @getPermissions="getPermissions"
        @getOtherData="updateOtherData"
        @handleAddButton="handleOpenAddPin"
      >
        <template slot-scope="{ items, itemsLoading }">
          <LoadingWrapper :loading="itemsLoading">
            <template #loading>
              <Loading :count="5" />
            </template>
            <template #default>
              <b-row class="margin-0 padding-x-16">
                <b-col
                  cols="12"
                  v-for="(item, index) in generateItems(items)"
                  :key="`activity-${index}`"
                  class="padding-0"
                >
                  <ActivityItem :item="item" :isReadonly="isReadonly" />
                </b-col>
              </b-row>
            </template>
          </LoadingWrapper>
        </template>
        <template #empty-box>
          <b-row class="margin-0 padding-16">
            <b-col
              cols="12"
              class="border--dashed border--complementary-100 border-radius-8 padding-y-32 flex-center flex-direction-column"
            >
              <div
                class="font-size-14 color-complementary-300 margin-bottom-16"
              >
                {{ $lang.clickForAddNewActivity }}
              </div>
              <Button
                rightIcon="plus"
                variant="complementary"
                :text="$lang.newActivity"
                :disabled="isReadonly"
                @click="handleOpenAddPin"
              />
            </b-col>
          </b-row>
        </template>
      </ListWrapper>
      <AddPin :visible="isAddPin" @handleClose="handleCloseAddPin" />
    </b-col>
  </b-row>
</template>

<script>
import { ListWrapper } from "@/components/re-design";
import LoadingWrapper from "../loading-wrapper/LoadingWrapper.vue";
import { Button } from "@/components/re-design/forms";
import Loading from "./Loading.vue";
import ActivityItem from "./ActivityItem.vue";
import AddPin from "./AddPin.vue";
import { pathOr } from "ramda";
import { computed, provide, ref, toRefs } from "vue";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    ListWrapper,
    LoadingWrapper,
    Loading,
    ActivityItem,
    AddPin,
    Button,
  },
  props: {
    resourceName: {
      type: String,
      default: "",
    },
    resourceValue: {
      type: [String, Number],
      default: null,
    },
    termCode: {
      type: String,
      default: null,
    },
    termId: {
      type: Number,
      default: null,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // bind props
    const { resourceName, resourceValue, termCode, termId, isReadonly } =
      toRefs(props);

    const listUrl = generateApiUrl(
      ["globalServices", "activities"],
      [resourceName.value, resourceValue.value]
    );

    // handle permissions
    const permissions = ref([]);
    const getPermissions = (data) => (permissions.value = data);

    // handle other data
    const otherData = ref(null);
    const updateOtherData = (data) => (otherData.value = data);

    // handle reload list
    const listWrapperReference = ref(null);
    const handleReloadList = () => listWrapperReference.value.reload();

    // generate list
    const generateItems = (items) => {
      return items.map((item) => {
        return {
          id: pathOr("", ["id"], item),
          caption: pathOr("", ["caption"], item),
          guideText: pathOr("", ["guide_text"], item),
        };
      });
    };

    // handle add
    const isAddPin = ref(false);
    const handleOpenAddPin = () => (isAddPin.value = true);
    const handleCloseAddPin = () => (isAddPin.value = false);

    // provide data
    provide(
      "PERMISSIONS",
      computed(() => permissions.value)
    );
    provide("handleReloadList", handleReloadList);
    provide(
      "RESOURCE_NAME",
      computed(() => resourceName.value)
    );
    provide(
      "RESOURCE_VALUE",
      computed(() => resourceValue.value)
    );
    provide(
      "TERM_CODE",
      computed(() => termCode.value)
    );
    provide(
      "TERM_ID",
      computed(() => termId.value)
    );
    provide(
      "IS_READONLY",
      computed(() => isReadonly.value)
    );

    // return data to be used in template
    return {
      listUrl,
      listWrapperReference,
      permissions,
      getPermissions,
      generateItems,
      isAddPin,
      handleOpenAddPin,
      handleCloseAddPin,
      updateOtherData,
      isReadonly,
    };
  },
};
</script>
